import {QuotePDFBuilder} from "./QuotePDFBuilder";
import {MiscPrice} from "../../../../../api/MiscPricing";
import {QuoteMiscPrice} from "../../../../../api/QuoteMiscPricing";

export function addMiscSection(bld: QuotePDFBuilder, props: {
    miscPrices: MiscPrice[]|QuoteMiscPrice[]
}) {
    props.miscPrices.map(m => {
        if (!m.publicNote && !m.extendedPrice) return;

        bld.addSection({
            title: m.name,
            note: [m.publicNote],
            includeIfNoRows: true,
            subTotal: m.extendedPrice,
            miscSubCategory: m.name,
            categories: []
        }, [], [], [m] as any);
    })
}